import { CustomNavLink } from "./Components"
import { useModal } from "../../../hooks/useModal";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDataTable } from "../../../hooks/useDataTable";

export const TextButton = ({name, data, to, label, onClick = () => {}, confirm, onConfirm = () => {}, color, children, updateTable = true}) => {
    const {t} = useTranslation();
    const {openConfirm} = useModal();
    const {updateRowDataTable, submitting, setSubmitting} = useDataTable();
    const onClickAction = async (e) => {
        e.preventDefault();
        if(submitting) return;
        if (confirm) {
            return openConfirm(confirm, async () => {
                if (onConfirm) {
                    setSubmitting({ name, id: data.id });
                    const result = await onConfirm();
                    if (data && updateRowDataTable && updateTable) updateRowDataTable(result);
                    setSubmitting(null);
                } 
            });
        }
    }
    return (
        <CustomNavLink to={""} $label={label} $color={color} onClick={onClickAction}>
            {submitting && submitting.name === name && submitting.id === data.id?t("Submitting..."):children}
        </CustomNavLink>
    )
}